import {
  ConstructorElementType,
  ConstructorGridType,
} from '@/interfaces/constructor.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';
import instanceOfGrid from '@/utils/instanceOfGrid';

/**
 * Возвращает массив полей объекта автомобиля, которые должны быть включены в ответ от сервера.
 * Данная функция выступает в качестве оптимизации, для уменьшения размера возвращаемого объекта.
 * @param constructorGrid Конфигурация блоков, использующихся на странице для отображения информации по автомобилю.
 * @param config Объект настроек приложения
 * @returns Массив полей из объекта автомобиля @example ['model', 'price', 'version', 'engine']
 */
function getCarFields(
  constructorGrid: ConstructorGridType,
  config: ISettings,
): Array<string> {
  const fields = findFieldsInGridItems(constructorGrid.items);

  return filterDisabledBlocksFields(
    new Set([...(constructorGrid.fields || []), ...fields]),
    config,
  );
}

/**
 * Фильтрует поля, отключенного функционала.
 * Например: если отключен функционал выгод, то информация о них не будет
 * отображаться, как в блоке выгод, так и в блоке цены.
 * @param fields список полей автомобиля
 * @param config объект конфигурации приложения
 */
function filterDisabledBlocksFields(
  fields: Set<string>,
  config: ISettings,
): Array<string> {
  if (!config.benefits?.enable) {
    fields.delete('benefits');
    fields.delete('maxBenefit');
  }

  if (!config.tags?.enable) {
    fields.delete('tags');
  }

  return Array.from(fields);
}

/**
 * Вспомогательная функция, собирающая массив типов блоков, использующихся в сетке.
 */
function findFieldsInGridItems(items: Array<ConstructorElementType>): Array<string> {
  const fields: string[] = [];

  items.forEach(item => {
    if (item.fields) {
      fields.push(...item.fields);
    }
    if (instanceOfGrid(item)) {
      fields.push(...findFieldsInGridItems(item.items));
    }
  });

  return Array.from(fields);
}

export default getCarFields;
